import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { appendApplicationId, getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import CustomerModal from './CustomerModal';
import CustomerGrid from './CustomerGrid';
import { logAuditEvent } from '../../utils/auditLogger';

function CustomerMain(props) {
  const [customerList, setCustomerList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const moduleName = props.Module || 'Customer';
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchCustomers();
  }, [props.Module]);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Customer');
  }, [moduleName]);

  function openAddModal() {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add customer modal');
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const customerModel = data;
      if(customerModel){
        let customerDetails = {
          CustomerId: null,
          CustomerName: customerModel.CustomerName ? customerModel.CustomerName : "",
          Occupation: customerModel.Occupation ? customerModel.Occupation : "",
          MobileNumber: customerModel.MobileNumber ? customerModel.MobileNumber : "",
          EmailId: customerModel.EmailId ? customerModel.EmailId : "",
          AddressLine1: customerModel.AddressLine1 ? customerModel.AddressLine1 : "",
          AddressLine2: customerModel.AddressLine2 ? customerModel.AddressLine2 : "",
          AddressLine3: customerModel.AddressLine3 ? customerModel.AddressLine3 : "",
          City: customerModel.City ? customerModel.City : "",
          State: customerModel.State ? customerModel.State : "",
          Country: customerModel.Country ? customerModel.Country : "",
          PinNumber: customerModel.PinNumber ? customerModel.PinNumber : "",
          OfficeAddressLine1: customerModel.OfficeAddressLine1 ? customerModel.OfficeAddressLine1 : "",
          OfficeAddressLine2: customerModel.OfficeAddressLine2 ? customerModel.OfficeAddressLine2 : "",
          OfficeAddressLine3: customerModel.OfficeAddressLine3 ? customerModel.OfficeAddressLine3 : "",
          OfficeCity: customerModel.OfficeCity ? customerModel.OfficeCity : "",
          OfficeState: customerModel.OfficeState ? customerModel.OfficeState : "",
          OfficeCountry: customerModel.OfficeCountry ? customerModel.OfficeCountry : "",
          OfficePinNumber: customerModel.OfficePinNumber ? customerModel.OfficePinNumber : "",
          Reference1Name: customerModel.Reference1Name ? customerModel.Reference1Name : "",
          Reference1MobileNumber: customerModel.Reference1MobileNumber ? customerModel.Reference1MobileNumber : "",
          Reference2Name: customerModel.Reference2Name ? customerModel.Reference2Name : "",
          Reference2MobileNumber: customerModel.Reference2MobileNumber ? customerModel.Reference2MobileNumber : "",
          AnualIncome: customerModel.AnualIncome ? customerModel.AnualIncome : "",
          FamilyMemberName: customerModel.FamilyMemberName ? customerModel.FamilyMemberName : "",
          FamilyMemberMobileNumber: customerModel.FamilyMemberMobileNumber ? customerModel.FamilyMemberMobileNumber : "",
          DOB: customerModel.DOB ? customerModel.DOB : "",
          UserId: getStorageValues('userId')
        };
        if (validation(customerDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/customer/save",
              customerDetails
            );
            if (response.status === 200) {
              const payload = response.data.data && response.data.data[0] ? response.data.data[0] : null;
              if(payload && payload.success === 1){
                const newCustomerId = payload.CustomerId;
                if (customerModel.PendingFiles && customerModel.PendingFiles.length && newCustomerId) {
                  await uploadPendingFiles(newCustomerId, customerModel.PendingFiles);
                }
                CreateAlert(payload.message, "Success", setAlert);
                fetchCustomers();
                closeModal();
              } else {
                CreateAlert(payload?.message || "Unable to save customer", "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    } 
  }
  function validation(customerDetails) {
    var validation = true;
      if (customerDetails) {
      if (customerDetails.CustomerName !== null && customerDetails.CustomerName !== undefined) {
        if (customerDetails.CustomerName.length === 0) {
          CreateAlert("Please enter customer!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter customer!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }
  const fetchCustomers = async () => {
    try {
      const body = { UserId: getStorageValues('userId') };
      const response = await axios.post(getApiBaseUrl() + "/customer/getall", body);
      if (response.status === 200) {
        setCustomerList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const uploadPendingFiles = async (customerId, pendingFiles = []) => {
    const groups = pendingFiles.reduce((acc, item) => {
      const key = item.FileCategory || 'General';
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    for (const [category, files] of Object.entries(groups)) {
      const formData = new FormData();
      formData.append('entityId', customerId);
      formData.append('entityType', 'customer');
      formData.append('fileCategory', category);
      formData.append('fileTitle', files[0]?.FileTitle || '');
      formData.append('UserId', getStorageValues('userId'));
      files.forEach((file) => {
        if (file.file) {
          formData.append('files', file.file, file.OriginalName);
        }
      });
      appendApplicationId(formData);
      await axios.post(getApiBaseUrl() + "/file/upload", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  };
  const handleExportExcel = () => {
    const columns = [
      { name: "Customer", selector: "CustomerName" },
      { name: "Mobile", selector: "MobileNumber" },
      { name: "Email", selector: "EmailId" },
      { name: "City", selector: "City" },
      { name: "State", selector: "State" },
      { name: "Country", selector: "Country" },
      { name: "Pin", selector: "PinNumber" },
    ];
    exportToExcel("Customers", columns, customerList);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Customer", selector: "CustomerName" },
      { name: "Mobile", selector: "MobileNumber" },
      { name: "Email", selector: "EmailId" },
      { name: "City", selector: "City" },
      { name: "State", selector: "State" },
      { name: "Country", selector: "Country" },
      { name: "Pin", selector: "PinNumber" },
    ];
    exportToPDF("Customers", columns, customerList);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={fetchCustomers}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <CustomerGrid CustomerData={customerList} fetchCustomers={fetchCustomers} UserPermissions={getUserModulePermission} moduleName={moduleName}/>
      <CustomerModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}
        moduleName ={props.Module}
      />
    </>
  )
}

export default CustomerMain